import React from 'react';
import { Dispatch } from 'redux';
import { connect } from "react-redux";
import { IApplicationState, RootActionCreators } from '../../../store';
import { createStyles, makeStyles, useTheme, Theme } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { INavigations, mapNavigationsToProps, ContactpointNavigation, ContactpointNavigationPage } from '../../organisms/contactpoint/ContactpointNavigation';
import { IData as IContactpointItem, defaultContactpointItem as EmptyContactpointItem } from "../../../store/contactpoint/ContactpointItem";
import { PageHeader } from '../../organisms/PageHeader';
import { ContactpointForm } from '../../organisms/contactpoint/ContactpointForm';

import { FetchState } from '../../../entities/FetchState';
import { IReportDataObject } from '../../../entities/reports/IReportData';
import ErrorMessage from '../../organisms/ErrorMessage';
import { SavingMessage } from '../../organisms/SavingMessage';
import { SaveButton } from '../../atoms/buttons/SaveButton';

// CSS
const useStyles = makeStyles((theme: Theme) =>
    createStyles({}),
); 

// Standard Properties from parent component
interface IProps { }

// Outgoing functions to parent component
interface IDispatch {}

// Properties from State 
interface IStateProps {
    updateItemState: IReportDataObject<IContactpointItem>
}
const mapStateProps = (state: IApplicationState): IStateProps => ({
    updateItemState: state.contactpoint.contactpointItem.UpdateItem
});

// Outgoing functions to Dispatch
interface IDispatchProps {
    navigations: INavigations;
    onSave: (details: IContactpointItem) => void;
}
const mapDispatchProps = (dispatch: Dispatch): IDispatchProps => ({
    navigations: mapNavigationsToProps(dispatch),
    onSave: (details: IContactpointItem) => dispatch(RootActionCreators.Contactpoint.contactpointItem.UpdateData(details))
});

// Actual Component
export type AllProps = IProps & IDispatch & IStateProps & IDispatchProps;
export const ContactpointNew = (props: AllProps) => {
    const classes = useStyles(useTheme());
    const { t: tContactpoint } = useTranslation('contactpoint');
    const { t: tCommon } = useTranslation('common');

    // Create a new contactpoint item which is invalid by default
    const [details, setDetails] = React.useState<IContactpointItem>({...EmptyContactpointItem, id: crypto.randomUUID()});
    const [isValid, setIsValid] = React.useState(true);

    return (
        <ContactpointNavigation navigations={props.navigations} selected={ContactpointNavigationPage.New}>
            <PageHeader 
                title={tContactpoint('newContactpointPageTitle')} 
                subTitle={tContactpoint('newContactpointPageSubtitle')} 
                explainText={tContactpoint('newContactpointPageExplanation')} 
            />
            
            <ContactpointForm
                data={details}
                onUpdate={(data, isValid) => {setDetails(data); setIsValid(isValid); }}
                loading={false}
                prevalidate={false}
                actions={
                    <SaveButton 
                        disabled={!isValid} 
                        onClick={() => props.onSave(details)} 
                    />
                }
            />

            {props.updateItemState.state === FetchState.Busy && 
                <SavingMessage entity={tContactpoint('contactpoint')} />
            }
            
            {props.updateItemState.state === FetchState.Error && 
                <ErrorMessage 
                    title={tCommon('savingErrorTitle')} 
                    message={tCommon('savingErrorXMessage', {x: props.updateItemState.errorMessage})} 
                    canClose 
                    options={[]} 
                    errorDetails={JSON.stringify(details)} 
                />
            }
        </ContactpointNavigation>
    );
};

// Connected component for actual use in the app
export default connect<IStateProps, IDispatchProps, {}, IApplicationState>(mapStateProps, mapDispatchProps)(ContactpointNew);
